const DropdownOptions = {
    TYPES: 'types',
    DECISIONS: 'decisions',
};

export default DropdownOptions;